(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["cafe-locations"] && !Shopify.designMode) return;
  try {
    
  (function() {
    const LEAFLET_STYLE_ID = 'leaflet-stylesheet';
    const LEAFLET_SCRIPT_ID = 'leaflet-script';
    const LEAFLET_STYLE_URL = 'https://unpkg.com/leaflet@1.9.4/dist/leaflet.css';
    const LEAFLET_SCRIPT_URL = 'https://unpkg.com/leaflet@1.9.4/dist/leaflet.js';

    function ensureLeaflet() {
      if (window.L) return Promise.resolve(window.L);
      if (window.__leafletLoadPromise) return window.__leafletLoadPromise;

      window.__leafletLoadPromise = new Promise((resolve, reject) => {
        if (!document.getElementById(LEAFLET_STYLE_ID)) {
          const link = document.createElement('link');
          link.id = LEAFLET_STYLE_ID;
          link.rel = 'stylesheet';
          link.href = LEAFLET_STYLE_URL;
          document.head.appendChild(link);
        }

        const existingScript = document.getElementById(LEAFLET_SCRIPT_ID);
        if (existingScript) {
          existingScript.addEventListener('load', () => resolve(window.L), { once: true });
          existingScript.addEventListener('error', reject, { once: true });
          return;
        }

        const script = document.createElement('script');
        script.id = LEAFLET_SCRIPT_ID;
        script.src = LEAFLET_SCRIPT_URL;
        script.async = true;
        script.onload = () => resolve(window.L);
        script.onerror = reject;
        document.head.appendChild(script);
      });

      return window.__leafletLoadPromise;
    }

    const sections = document.querySelectorAll('.locations');
    if (!sections.length) return;

    sections.forEach((section) => {
      if (section.dataset.mapInitialized === 'true') return;

      const mapElement = section.querySelector('[data-locations-map]');
      const cards = Array.from(section.querySelectorAll('[data-location-card]'));
      if (!mapElement || !cards.length) return;

      const points = cards.map((card, index) => {
        const latitude = Number(card.dataset.latitude);
        const longitude = Number(card.dataset.longitude);

        if (!Number.isFinite(latitude) || !Number.isFinite(longitude)) return null;

        return {
          card,
          index,
          latitude,
          longitude,
          name: card.dataset.locationName || '',
          address: card.dataset.locationAddress || '',
          mapLink: card.dataset.locationMapLink || ''
        };
      }).filter(Boolean);

      if (!points.length) return;
      section.dataset.mapInitialized = 'true';

      ensureLeaflet().then((L) => {
        const map = L.map(mapElement, {
          scrollWheelZoom: false,
          zoomControl: false
        });

        L.tileLayer('https://{s}.basemaps.cartocdn.com/light_all/{z}/{x}/{y}{r}.png', {
          subdomains: 'abcd',
          maxZoom: 20,
          attribution: '&copy; OpenStreetMap contributors &copy; CARTO'
        }).addTo(map);

        const defaultStyle = {
          radius: 8,
          color: '#f7f4ee',
          weight: 2,
          fillColor: '#4a6741',
          fillOpacity: 1
        };

        const activeStyle = {
          radius: 10,
          color: '#f7f4ee',
          weight: 3,
          fillColor: '#8b6f3a',
          fillOpacity: 1
        };

        const markers = points.map((point) => {
          const marker = L.circleMarker([point.latitude, point.longitude], defaultStyle).addTo(map);
          const popupParts = [
            '<strong>' + point.name + '</strong>',
            point.address
          ];

          if (point.mapLink) {
            popupParts.push('<a href="' + point.mapLink + '" target="_blank" rel="noopener noreferrer">Directions</a>');
          }

          marker.bindPopup(popupParts.join('<br>'));
          return marker;
        });

        function activateLocation(index, shouldScroll) {
          points.forEach((point, pointIndex) => {
            const isActive = pointIndex === index;
            point.card.classList.toggle('location-card--active', isActive);
            point.card.setAttribute('aria-expanded', isActive ? 'true' : 'false');
            markers[pointIndex].setStyle(pointIndex === index ? activeStyle : defaultStyle);
          });

          const activePoint = points[index];
          map.flyTo([activePoint.latitude, activePoint.longitude], Math.max(map.getZoom(), 14), {
            animate: true,
            duration: 0.75
          });
          markers[index].openPopup();

          if (shouldScroll) {
            activePoint.card.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
          }
        }

        points.forEach((point, index) => {
          point.card.addEventListener('click', () => activateLocation(index, false));
          point.card.addEventListener('keydown', (event) => {
            if (event.key !== 'Enter' && event.key !== ' ') return;
            event.preventDefault();
            activateLocation(index, false);
          });

          markers[index].on('click', () => activateLocation(index, true));
        });

        if (points.length === 1) {
          map.setView([points[0].latitude, points[0].longitude], 14);
        } else {
          const bounds = L.latLngBounds(points.map((point) => [point.latitude, point.longitude]));
          map.fitBounds(bounds.pad(0.25));
        }

        activateLocation(0, false);
      }).catch(() => {
        section.dataset.mapInitialized = 'failed';
      });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["experience-journey"] && !Shopify.designMode) return;
  try {
    

(function () {
  'use strict';

  /* ── Helpers ── */
  function pad2(n) {
    return n < 10 ? '0' + n : String(n);
  }

  function clamp(value, min, max) {
    return Math.min(Math.max(value, min), max);
  }

  /* ── Bootstrap every journey section on the page ── */
  document.querySelectorAll('[data-journey]').forEach(function (journey) {
    initJourney(journey);
  });

  function initJourney(journey) {
    var track        = journey.querySelector('.journey__track');
    var sticky       = journey.querySelector('.journey__sticky');
    var slides       = Array.from(journey.querySelectorAll('.journey__slide'));
    var dots         = Array.from(journey.querySelectorAll('.journey__dot'));
    var images       = Array.from(journey.querySelectorAll('[data-journey-image]'));
    var counterEl    = journey.querySelector('.journey__counter-current');
    var progressFill = journey.querySelector('.journey__progress-fill');
    var scrollHint   = journey.querySelector('.journey__scroll-hint');
    var loopBadge    = journey.querySelector('.journey__loop-badge');

    var stageCount   = parseInt(journey.dataset.stageCount, 10) || slides.length;
    var autoplay     = journey.dataset.autoplay === 'true';
    var autoplayMs   = parseInt(journey.dataset.autoplaySpeed, 10) || 4000;

    /* Set the CSS custom property for track height calculation */
    journey.style.setProperty('--journey-stages', stageCount);

    var currentStage   = 0;
    var loopMode       = false;   /* true when scroll has passed the last stage */
    var loopTimer      = null;
    var rafId          = null;
    var lastScrollY    = -1;

    /* ── Activate a specific stage ── */
    function goToStage(index, fromLoop) {
      if (index === currentStage && !fromLoop) return;

      /* Mark exiting */
      slides[currentStage].classList.remove('is-active');
      slides[currentStage].classList.add('is-exiting');
      slides[currentStage].setAttribute('aria-hidden', 'true');
      dots[currentStage] && dots[currentStage].classList.remove('is-active');
      dots[currentStage] && dots[currentStage].setAttribute('aria-current', 'false');

      /* Clean up exiting class after transition completes */
      var exitingSlide = slides[currentStage];
      setTimeout(function () {
        exitingSlide.classList.remove('is-exiting');
      }, 900);

      currentStage = ((index % stageCount) + stageCount) % stageCount;

      /* Activate incoming */
      slides[currentStage].classList.add('is-active');
      slides[currentStage].setAttribute('aria-hidden', 'false');
      dots[currentStage] && dots[currentStage].classList.add('is-active');
      dots[currentStage] && dots[currentStage].setAttribute('aria-current', 'true');

      /* Update counter */
      if (counterEl) counterEl.textContent = pad2(currentStage + 1);

      /* Update progress bar */
      if (progressFill) {
        var pct = ((currentStage + 1) / stageCount * 100).toFixed(1) + '%';
        progressFill.style.width = pct;
      }

      /* Hide scroll hint after first stage */
      if (scrollHint && currentStage > 0) {
        scrollHint.classList.add('is-hidden');
      } else if (scrollHint && currentStage === 0) {
        scrollHint.classList.remove('is-hidden');
      }
    }

    /* ── Parallax: update image position for the active stage ── */
    function applyParallax(stageIndex, progress) {
      var img = images[stageIndex];
      if (!img) return;
      /* progress: 0 (stage just entered) → 1 (stage about to leave)
         shift image -5% → +5% relative to stage scroll progress          */
      var yPct = (progress - 0.5) * 10;
      img.style.transform = 'translateY(' + yPct.toFixed(2) + '%)';
      img.style.setProperty('--parallax-y', yPct.toFixed(2) + '%');
    }

    /* ── Main scroll handler ── */
    function onScroll() {
      var scrollY    = window.scrollY;
      if (scrollY === lastScrollY) return;
      lastScrollY = scrollY;

      var rect        = track.getBoundingClientRect();
      var trackHeight = track.offsetHeight;
      var vh          = window.innerHeight;

      /* How far scrolled into the track (px) */
      var scrolled = -rect.top;

      /* Entrance: not yet reached section */
      if (scrolled < 0) {
        if (loopMode) stopLoop();
        return;
      }

      /* Past the section — enter/stay in loop mode */
      var maxScroll = trackHeight - vh;
      if (scrolled >= maxScroll) {
        if (!loopMode && autoplay) startLoop();
        return;
      }

      /* Inside scroll tunnel — stop any loop */
      if (loopMode) stopLoop();

      /* Each stage occupies equal scroll space */
      var scrollPerStage = maxScroll / stageCount;
      var rawStage       = scrolled / scrollPerStage;
      var stageIndex     = clamp(Math.floor(rawStage), 0, stageCount - 1);
      var withinStage    = rawStage - stageIndex; /* 0–1 within current stage */

      goToStage(stageIndex);
      applyParallax(stageIndex, withinStage);
    }

    /* ── rAF loop so parallax is smooth ── */
    function scheduleFrame() {
      onScroll();
      rafId = requestAnimationFrame(scheduleFrame);
    }

    /* ── Auto-loop (infinite cycling after scroll tunnel) ── */
    function startLoop() {
      if (loopMode) return;
      loopMode = true;
      loopBadge && loopBadge.classList.add('is-visible');
      tick();
    }

    function tick() {
      if (!loopMode) return;
      loopTimer = setTimeout(function () {
        if (!loopMode) return;
        goToStage(currentStage + 1, true);
        tick();
      }, autoplayMs);
    }

    function stopLoop() {
      loopMode = false;
      clearTimeout(loopTimer);
      loopBadge && loopBadge.classList.remove('is-visible');
    }

    /* ── Dot click: scroll to the corresponding stage ── */
    dots.forEach(function (dot) {
      dot.addEventListener('click', function () {
        var index      = parseInt(dot.dataset.dot, 10);
        var rect       = track.getBoundingClientRect();
        var trackH     = track.offsetHeight;
        var vh         = window.innerHeight;
        var maxScroll  = trackH - vh;
        var perStage   = maxScroll / stageCount;
        /* Scroll to the midpoint of the stage's scroll range */
        var targetY    = window.scrollY + rect.top + index * perStage + perStage * 0.5;
        window.scrollTo({ top: targetY, behavior: 'smooth' });
      });
    });

    /* ── Keyboard navigation (arrow keys while section is in view) ── */
    document.addEventListener('keydown', function (e) {
      var rect = sticky.getBoundingClientRect();
      var inView = rect.top <= 0 && rect.bottom >= window.innerHeight;
      if (!inView) return;

      if (e.key === 'ArrowDown' || e.key === 'ArrowRight') {
        e.preventDefault();
        var next = currentStage + 1;
        if (next < stageCount) {
          var dotBtn = dots[next];
          dotBtn && dotBtn.click();
        }
      } else if (e.key === 'ArrowUp' || e.key === 'ArrowLeft') {
        e.preventDefault();
        var prev = currentStage - 1;
        if (prev >= 0) {
          var dotBtn = dots[prev];
          dotBtn && dotBtn.click();
        }
      }
    });

    /* ── Start ── */
    goToStage(0, true);
    rafId = requestAnimationFrame(scheduleFrame);
  }

})();


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hero-banner"] && !Shopify.designMode) return;
  try {
    
  (function() {
    const heroes = document.querySelectorAll('[data-hero-banner]');
    if (!heroes.length) return;

    heroes.forEach((hero) => {
      if (hero.dataset.initialized === 'true') return;
      hero.dataset.initialized = 'true';

      const slides = hero.querySelectorAll('.hero__slide');
      const dots = hero.querySelectorAll('.hero__dot');
      if (slides.length < 2) return;

      const autoplayMs = Number(hero.dataset.autoplayMs) || 5000;
      let current = 0;
      let intervalId;

      function goSlide(n) {
        slides[current].classList.remove('hero__slide--active');
        if (dots[current]) {
          dots[current].classList.remove('hero__dot--active');
          dots[current].setAttribute('aria-selected', 'false');
        }

        current = n;
        slides[current].classList.add('hero__slide--active');
        if (dots[current]) {
          dots[current].classList.add('hero__dot--active');
          dots[current].setAttribute('aria-selected', 'true');
        }
      }

      function startAutoplay() {
        clearInterval(intervalId);
        intervalId = setInterval(() => goSlide((current + 1) % slides.length), autoplayMs);
      }

      dots.forEach((dot, i) => dot.addEventListener('click', () => goSlide(i)));
      hero.addEventListener('mouseenter', () => clearInterval(intervalId));
      hero.addEventListener('mouseleave', startAutoplay);

      startAutoplay();
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-cart"]) return;
  try {
    
  function updateQty(index, delta) {
    var input = document.querySelector('#qty-' + index);
    if (!input) return;
    var val = Math.max(0, parseInt(input.value, 10) + delta);
    input.value = val;
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-product"]) return;
  try {
    
  (function() {
    const thumbs = document.querySelectorAll('.product-page__thumb');
    const images = document.querySelectorAll('.product-page__image-wrap');
    thumbs.forEach(function(thumb) {
      thumb.addEventListener('click', function() {
        const idx = this.dataset.index;
        images.forEach(function(img) { img.classList.remove('product-page__image-wrap--active'); });
        thumbs.forEach(function(t)   { t.classList.remove('product-page__thumb--active'); });
        document.querySelector('.product-page__image-wrap[data-index="' + idx + '"]').classList.add('product-page__image-wrap--active');
        this.classList.add('product-page__thumb--active');
      });
    });
    const qtyInput = document.querySelector('.product-page__qty-input');
    document.querySelectorAll('.product-page__qty-btn').forEach(function(btn) {
      btn.addEventListener('click', function() {
        const current = parseInt(qtyInput.value, 10);
        const isIncrease = btn.textContent.trim() === '+';
        qtyInput.value = isIncrease ? current + 1 : Math.max(1, current - 1);
      });
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
